import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { GET_DMX_PROFILES } from './actionTypes';
import { getDmxProfilesSuccess, getDmxProfilesError } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* getProfiles({ payload: { user, deviceType } }) {
  try {
    const response = yield call(dmxAPI.getProfiles, user.token, deviceType);
    yield put(getDmxProfilesSuccess(response));
  } catch (error) {
    yield put(getDmxProfilesError(error));
  }
}

export function* watchGetDmxProfiles() {
  yield takeEvery(GET_DMX_PROFILES, getProfiles);
}

function* getDmxProfilesSaga() {
  yield all([fork(watchGetDmxProfiles)]);
}

export default getDmxProfilesSaga;
